import { Shimmer } from '@flexo/atoms';
import { useTranslation } from 'react-i18next';
import styles from './payments-list.module.scss';

export interface PaymentsListSkeletonProps {
  title?: string;
}

/**
 * Skeleton component for PaymentsList
 * Displays loading placeholder while invoices are being fetched
 */
export function PaymentsListSkeleton({ title }: PaymentsListSkeletonProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.Payments__List}>
      {/* Title - real text, no click, black color, no chevron */}
      <p className={styles.Payments__List__Title__Loading}>
        {title ? t(title) : ''}
      </p>

      <div className={styles.Payments__List__Content}>
        {/* Render 4 skeleton period items to match the actual content */}
        {[0, 1, 2, 3].map((index) => (
          <div
            className={styles.Payments__List__Content__Period__Wrapper__Skeleton}
            key={`skeleton-period-${index}`}
          >
            <div className={styles.Payments__List__Content__Period__Info}>
              <div className={styles.Payments__List__Content__Period__Title__Skeleton}>
                <Shimmer borderRadius="4px" />
              </div>
              <div className={styles.Payments__List__Content__Period__Status__Skeleton}>
                <Shimmer borderRadius="4px" />
              </div>
            </div>
            <div className={styles.Payments__List__Content__Period__Amount__Skeleton}>
              <Shimmer borderRadius="4px" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PaymentsListSkeleton;
